import React,{useContext,createContext,useReducer,useEffect,useState} from "react"
import Header from "./Header";
import TopPanel from "./TopPanel";
import CenterPanel from "./CenterPanel";
import Footer from "./Footer";
import AppContext from "./AppContext";

import LoginScreen from "./LoginScreen";
import LoadingMask from "./LoadingMask";
import Api, { TOKEN } from "./Api";
import YearMonthSelector from "./YearMonthSelector";
import { useGlobal } from "./Reducer";
import Alert from "./Alert";
import BooleanAlert from "./BooleanAlert";
import queryString from "query-string";
import DownLogos from "./DownLogos";
import StickyBanner from "./StickyBanner";


    export default(props)=>
    {
       
      

        
       
       const [globalState, globalActions] = useGlobal();
    
        const {accessToken,accesstoken,month}=queryString.parse(props.location.search, { ignoreQueryPrefix: true })

        const [s_accessToken,setS_accessToken]=useState(accessToken||accesstoken);
        const [s_month,setS_month]=useState(month);
        const [error,setError]=useState(null);
        
        

        const openAction=()=>{
         
             globalActions.loading(true);
             Api.getDataForMonth(s_month).then(({DATA,RESULT})=>{
                 globalActions.setAllData(DATA);
                 Api.recordAnalytics(DATA.id,"DOC_OPEN",s_month,s_month);
             }).catch(err=>{
     
             }).finally(()=>{
                globalActions.loading(false);
             });
        }

        

       
        useEffect(()=>{
        
            if(s_accessToken!=TOKEN)
            {
               setError("Invalid access token! "+s_accessToken);
               return;
            }
    
            openAction();
        },[globalState.appData.status])     
        


        

   
 
    
        return (
      
        
        <div    >
    {error==null &&<React.Fragment><div >
                 

        <Header/>
      
                    <TopPanel/>
                    <CenterPanel/>
                    <DownLogos/>
                    <Footer/>
        </div></React.Fragment>
    }
    {error!=null && <div style={{marginTop:200}} className="btn-danger  text-center">
            <h3>{error}</h3>

    </div>}
    <StickyBanner/>
        </div>
      );
    }


